var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"text-align":"left"}},[_c('p',{staticStyle:{"margin":"0px"}},[_vm._v(_vm._s(_vm.eventObject.eventType))]),_c('p',[_vm._v(_vm._s(_vm.eventObject.eventTime.toLocaleString()))])])
}
var staticRenderFns = []

export { render, staticRenderFns }